((window, document) => {

    // defer to body.onload as bootstrap wont be loaded yet
    window.addEventListener("DOMContentLoaded", () => {
        const bootstrap = window.bootstrap;
        if (bootstrap) {
            function getTargetHtml(target: string) {
                const content = document.querySelector(target)!;
                content.remove();
                content.classList.remove('d-none');
                return content.outerHTML;
            }

            [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]')).map(function (el: HTMLElement) {
                new bootstrap.Dropdown(el, {
                    autoClose: 'outside'
                })
            });

            [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function (el: HTMLElement) {
                new bootstrap.Popover(el, {
                    content: getTargetHtml(el.dataset.bsTarget!),
                    html: true,
                    sanitize: false
                })
            });
        }
    });
})(window, document);